import { getCookie, setCookie, cookieNames } from './shared/cookies'

window.addEventListener('DOMContentLoaded', () => {
  const cookieNotice = document.querySelector('.cookie-notice')
  const understandButton = cookieNotice.querySelector('.button')

  if (getCookie(cookieNames.profissaoUXDesignerAuth) != '1')
    cookieNotice.classList.toggle('-open')

  understandButton.addEventListener('click', () => {
    cookieNotice.classList.remove('-open')
    setCookie(cookieNames.profissaoUXDesignerAuth, '1')
  })
})
